<template>
  <div class="reminder_page">
    <div class="loading_wrap" v-if="!reminder">
      <van-loading color="#d6151e" type="spinner" size="48" />
    </div>

    <div class="reminder_wrap" v-else>
      <div class="reminder_card">
        <van-icon class="reminder_icon" name="warning-o" />
        <div class="reminder_title">{{ reminder.title }}</div>
        <div class="reminder_content">{{ reminder.content }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      reminders: {
        business: {
          type: "business",
          title: "出差提醒",
          content:
            "出差期间请注意人身财产安全，妥善保管好随身携带的载体和信息设备。",
        },
        workout: {
          type: "workout",
          title: "外出提醒",
          content:
            "外出期间请注意人身财产安全，妥善保管好随身携带的载体和信息设备。",
        },
      },
      reminder: null,
    };
  },
  mounted() {
    document.title = "消息提醒";
    const type = this.$route.params.type;
    this.reminder = this.reminders[type] || this.reminders.business;
  },
};
</script>

<style scoped src="./reminder.css"></style>
